module.exports = __webpack_public_path__ + "img/mascot.15f28524.png";